module.exports = __webpack_public_path__ + "1a8cfbc2f8fdc685df3bc690a1a26a2c.fbx";